export default __webpack_public_path__ + "static/media/purchase.07f1ea76.svg";